import { render, staticRenderFns } from "./monitor-select.vue?vue&type=template&id=0fd4e778&"
import script from "./monitor-select.vue?vue&type=script&lang=js&"
export * from "./monitor-select.vue?vue&type=script&lang=js&"
import style0 from "./monitor-select.vue?vue&type=style&index=0&id=0fd4e778&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports